/*
* @描述: 订单重新提交
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/17 15:58
*/
<template>
    <div>
        <van-popup v-model.sync="dialogVisible"
                   :style="{ width: '100%',height: '100%' }">
            <div class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleDialogClose"></ReturnNavBar>
                </div>
                <div class="detail_wrap_container">
                    <CustomFormMobile v-if="dataLoaded&&formInfoList.length"
                                  ref="orderForm"
                                  :field_form="'orders'"
                                  :field_list="formInfoList"
                                  :form_detail="orderFormData"
                                  :is_form_module="true"
                                  :pk_id="order_id"
                                  :is_recalculate="true"
                                  @submit-form="submitOrderFormData"/>
                    <div v-if="isApproval===1" class="add_approval_select_process">
                        <div class="m_page_little_title">
                            <span class="title">审批流程</span>
                        </div>
                        <div class="detail_chunk_wrap">
                            <approveProcessSelect ref="approveProcessSelectRef"
                                                  :approval_node_list="approval_node_list">
                            </approveProcessSelect>
                        </div>
                    </div>
                </div>
                <div class="add_footer_wrap">
                    <van-button :disabled="btnDisabled"
                                plain
                                type="info"
                                @click="handleDialogSave">保存
                    </van-button>
                    <van-button :disabled="btnDisabled"
                                size="large"
                                type="primary"
                                @click="handleDialogConfirm">提交
                    </van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import {getFormFields, orderAdd, getApprovalNodes, orderReSubmitDetail} from "@/api";
import {getBusinessIsApproval} from "@/utils";
import {pagination} from "@/mixins";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";

export default {
    name: "OrderSubmitAgain",
    data() {
        return {
            formInfoList: [],
            orderFormData: {
                project_quotation_id: ''
            },
            isApproval: 0,
            is_release: 1,
            importQuotationVisible: false,
            searchForm: {
                keyword: '',
                quotation_at: [],
            },
            defaultImg: require('@/assets/images/default.jpg'),
            approval_node_list: [],
            dataLoaded: false,
            btnDisabled: false,
            loading: false,
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: Number,
            default: 0,
        },
    },
    components: {CustomFormMobile, approveProcessSelect, ReturnNavBar},
    created() {
        this._getFromFields()
    },
    mixins: [pagination],
    methods: {
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'orders'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    this.getOrderDetail()
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        getOrderDetail() {
            orderReSubmitDetail({
                order_id: this.order_id
            }).then(res => {
                this.orderFormData = res.data
                this.orderFormData.order_goods = this.orderFormData.order_goods.filter(good => good.goods_status !== 0 && !good.goods_deleted_at)
                this.dataLoaded = true
                getBusinessIsApproval('order_add').then(res => {
                    this.isApproval = res
                    if (this.isApproval === 1) {
                        getApprovalNodes({
                            approval_type: 'order_add',
                        }).then(res => {
                            if (res.code === 200) {
                                this.approval_node_list = res.data
                                this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                            }
                            this.loading = false
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                })
            })
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取订单表单数据
        submitOrderFormData(data) {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.btnDisabled = true
            const formData = {
                ...data,
                is_release: this.is_release,
                node_list: this.approval_node_list,
                project_quotation_id: this.orderFormData.project_quotation_id,
                goods_cost_price: data.order_goods.reduce((total, item) => {
                    // 只处理 type 为 2 的商品
                    if (item.type === 1) {
                        // 计算价格
                        return total + (item.cost_price ? item.cost_price * item.num : 0);
                    }
                    return total; // 如果不满足条件，保持总值不变
                }, 0)
            }
            orderAdd(formData).then(res => {
                if (res.code === 200) {
                    this.$toast.fail(this.is_release === 0 ? '保存成功' : '新增成功')
                    this.$emit('refresh-list')
                    this.handleDialogClose()
                } else {
                    this.btnDisabled = false
                }
            })
        },

        //保存
        handleDialogSave() {
            this.is_release = 0
            this.$refs.orderForm.handleClickPublish(false)
        },

        // 确定
        handleDialogConfirm() {
            this.is_release = 1
            this.$refs.orderForm.handleClickPublish()
        },
    },
}
</script>
<style lang="scss" scoped>
.custom_form_body {
    height: 677px;
    padding: 24px;
}
</style>